import _ from 'lodash';
import moment from 'moment';
// ------------------------------------------------------------------------------------------------
export interface DateRangePickerLocale {
    /**
     * Text direction
     */
    direction?: 'ltr' | 'rtl';
    /**
     * Text for cancel label.
     */
    cancelLabel?: string;
    /**
     * Text for apply label.
     */
    applyLabel?: string;
    /**
     * Text for fromLabel label.
     */
    fromLabel?: string;
    /**
     * Text for toLabel label.
     */
    toLabel?: string;
    /**
     * Format of the date string. example: 'YYYY-MM-DD'
     */
    format?: string;
    /**
     * Separator between the startDate and endDate in the attached input element. Example: ' - '
     */
    separator?: string;
    /**
     * Text for the week label.
     */
    weekLabel?: string;
    /**
     * Text for the custom range label.
     */
    customRangeLabel?: string;
    /**
     * The first day of the week (0-6, Sunday to Saturday).
     */
    firstDay?: number;
    /**
     * Weekday names displayed in the header of calendar.
     */
    daysOfWeek?: string[];
    /**
     * Month names used in the month select boxes.
     */
    monthNames?: string[];
}
// ------------------------------------------------------------------------------------------------
export function GetDateRangePickerLocalizationDictionaryDefaultValues(): DateRangePickerLocale {
    return {
        direction: 'ltr',
        format: moment.localeData().longDateFormat('L'),
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: moment.localeData().firstDayOfWeek()
    };
}
// ------------------------------------------------------------------------------------------------
export function GetDateRangePickerLocalizationDictionary() {
    const res = {};

    // fill map with DateRangePicker locale keys
    const locale = GetDateRangePickerLocalizationDictionaryDefaultValues();
    res['applyLabel'] = locale.applyLabel;
    res['cancelLabel'] = locale.cancelLabel;
    res['customRangeLabel'] = locale.customRangeLabel;

    // for each entry of the array `daysOfWeek`
    _.forEach(locale.daysOfWeek, (dayofweek, index) => {
        // create an key containing element's index
        res['daysOfWeek_' + index] = dayofweek;
    });

    // for each entry of the array `monthNames`
    _.forEach(locale.monthNames, (monthName, index) => {
        // create an key containing element's index
        res['monthNames_' + index] = monthName;
    });
    return res;
}
// ------------------------------------------------------------------------------------------------